import { Controller } from '@hotwired/stimulus'
import AOS from 'aos'
import 'aos/dist/aos.css'

// Connects to data-controller="turbo-modal"
export default class extends Controller {
  connect() {
    AOS.init({
      offset: 80,
      delay: 50,
      duration: 500,
      easing: 'ease-in-out',
      once: false,
      mirror: false,
      anchorPlacement: 'top-bottom'
    })
  }
}
